import { AnchorHTMLAttributes, ReactNode } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

type LinkProps = Omit<NextLinkProps, 'as'> &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    children?: ReactNode;
    className?: string;
    href: string;
  };

export const Link = ({ children, href, ...otherProps }: LinkProps) => {
  return (
    <NextLink href={href} {...otherProps}>
      {children}
    </NextLink>
  );
};
